/** Shared mapping from grid column count (1..12) to a friendly fraction label. */
const FRACTIONS: Record<number, string> = {
  3: '1/4',
  4: '1/3',
  6: '1/2',
  8: '2/3',
  9: '3/4',
  12: 'pełna',
}

export function widthLabel(colWidth: number | undefined): string {
  const w = !colWidth || colWidth < 1 ? 12 : colWidth > 12 ? 12 : colWidth
  return FRACTIONS[w] ?? `${w}/12`
}
